import { trackEvent } from '../../_internal/usage-tracking';
export const trackHelpDeskInterceptEvent = ({
  action,
  component,
  onTrack
}) => trackEvent(onTrack, {
  key: 'help-desk-intercept',
  properties: {
    action,
    component
  }
});